// extracted by mini-css-extract-plugin
export var baseButton = "_ph-0";
export var controlsArrowKeys = "_ph-1";
export var controlsResetButton = "_ph-2";
export var lightGameButton = "_ph-4 _ph-0";
export var playAgainButton = "_ph-5 _ph-0";
export var startGameButton = "_ph-3 _ph-0";